






















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-ios14-info-quota-step-info';
export default defineComponent({
  name,
  props: {
    total: { type: Number, default: 9 },
    darkCount: { type: Number, default: 3 },
    lightCount: { type: Number, default: 2 },
    isHalfMode: { type: Boolean, default: false },
  },

  setup() {
    const getStepInfo = (num, darkCount, lightCount) => {
      if (num < darkCount) {
        return 'dark-color';
      } else if (num < darkCount + lightCount) {
        return 'light-color';
      }
      return 'gray-color';
    };

    return {
      name,
      getStepInfo,
    };
  },
});
